<template>
    <div>
        <v-row justify="end" class="row--small">
            
            <v-col cols="6" md="auto">
                <v-btn outlined small block color="secondary" class="min-w-md-120px" @click="addField('text-employer')">
                    <span>고용주 입력란 추가</span>
                </v-btn>
            </v-col>
            <v-col cols="6" md="auto">
                <v-btn outlined small block color="primary" class="min-w-md-120px" @click="addField('text-employee')">
                    <span>근로자 입력란 추가</span>
                </v-btn>
            </v-col>
            <v-col cols="6" md="auto">
                <v-btn outlined small block color="grey-d" class="min-w-md-120px" @click="addField('check')">
                    <span class="grey-6--text">체크박스 추가</span>
                </v-btn>
            </v-col>
            <v-col cols="6" md="auto">
                <v-btn outlined small block color="grey-d" class="min-w-md-120px" @click="addField('canvas')">
                    <span class="grey-6--text">서명 추가</span>
                </v-btn>
            </v-col>
            <!-- <v-col cols="6" md="auto">
                <v-btn outlined small block color="grey-d" class="min-w-md-120px" @click="addField('file')">
                    <span class="grey-6--text">이미지 추가</span>
                </v-btn>
            </v-col>
            <v-col cols="6" md="auto">
                <v-btn outlined small block color="secondary" class="min-w-md-120px" @click="addField(text)">
                    <span>텍스트 추가</span>
                </v-btn>
            </v-col> -->
        </v-row>
        <div class="scroll-primary mt-6 mt-lg-12">
            <div class="pdfImg">
                <v-img  v-if="base64Url" :src="base64Url">
                    <employment-form-field v-for="field in fieldArr" :value="field" :page="pageNumber" :key="field.dataLabel" @close="close" @update="update"/>
                </v-img>
                <canvas v-else :id="`canvas-${pageNumber}`"/>
            </div>
        </div>
    </div>
</template>

<script>
import EmploymentFormField from './employment-form-field.vue'

export default {
    components:{
        EmploymentFormField,
    },
    props:{
        page: { type: Object, default: ()=>({})},
        scale: { type: Number, default: 3 },
        pageNumber: { type: Number, default: 0},
        propsFields: { type: Array, default: ()=>([])}         // DB 저장된 field 값
    },
    data(){
        return{
            // blobUrl: null,
            base64Url:null,

            fieldArr: [],
        }
    },
    created(){
        },
    mounted() {
        this.getFieldPerPage();
        this.renderingPage();
        this.init();
    },
    methods: {
        init(){
            if(this.propsFields.length !== 0){
                this.$emit("update", JSON.parse(JSON.stringify(this.fieldArr)));
            }
        },
        async renderingPage(){
            const canvas= document.getElementById(`canvas-${this.pageNumber}`);

            let viewport = this.page.getViewport({ scale: this.scale });
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            const renderTask = this.page.render({ canvasContext: canvas.getContext('2d'), viewport })
            renderTask.promise.then(()=>{
                let base64Url = canvas.toDataURL();
                this.base64Url = base64Url;
                // let blob = this.converBase64toBlob(base64Url);
                // this.blobUrl = URL.createObjectURL(blob);
                this.$emit("pageMeta", { page: this.pageNumber, pageUrl: this.base64Url });
            })
        },
        //blob 파일로 변환이 더 가볍지만, url 만료 이슈
        // converBase64toBlob(base64URI){
        //     let BASE64_MARKER = ';base64,';
        //     let base64Index = base64URI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
        //     let base64 = base64URI.substring(base64Index);
        //     let raw = window.atob(base64);
        //     let byteArray = new Uint8Array(new ArrayBuffer(raw.length));

        //     for(let i = 0; i < raw.length; i++) {
        //         byteArray[i] = raw.charCodeAt(i);
        //     }
            
        //     let blob = new Blob([ byteArray ], { type: 'image/png'});
        //     return blob;
        // },
        addField(value){
            this.fieldArr.push({ dataLabel: Math.random().toString().slice(2), type: value, page: this.pageNumber });
        },
        close(value){
            const idx = this.fieldArr.findIndex((field)=> field.dataLabel === value.dataLabel);
            this.fieldArr.splice(idx,1);
        },
        update(value){
            const idx = this.fieldArr.findIndex((field)=> field.dataLabel === value.dataLabel);
            Object.assign(this.fieldArr[idx], { ...value });
            this.$emit("update", this.fieldArr);
        },
        // 각 페이지 별 field 값 배치
        getFieldPerPage(){
            if(this.propsFields.length > 0){
                let fieldDataArr = this.propsFields.filter((field) => field.page === this.pageNumber);

                for(let fieldData of fieldDataArr){
                    this.fieldArr.push(fieldData);
                }
            }
        },
    },
}
</script>

<style lang="scss" scope>
.scroll-primary{
    overflow-y: unset;
    overflow-x: auto;
}
.pdfImg{
    border: 1px solid #ddd;
    border-radius: 6px;
    max-width: unset;
    width: 976px;
    min-width: 976px;
}

</style>